import React from 'react';
import {
  Create,
  TabbedForm,
  FormTab,
  TopToolbar,
  ListButton,
} from 'react-admin';
import { parse } from 'query-string';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import IncomeForm from './IncomeForm';

const Actions = ({ person, legalPerson }) => (
  <TopToolbar>
    <ListButton
      to={
        person
          ? `/people/${person}/show/assets`
          : `/legal-people/${legalPerson}/show/assets`
      }
      label='ra.action.back'
      icon={<ChevronLeft />}
    />
  </TopToolbar>
);

const IncomeCreate = (props) => {
  const { person: personString, 'legal-person': legalPersonString } = parse(
    props.location.search
  );
  const person = personString ? parseInt(personString, 10) : '';
  const legalPerson = legalPersonString ? parseInt(legalPersonString, 10) : '';

  return (
    <Create
      title=''
      actions={<Actions person={person} legalPerson={legalPerson} />}
      {...props}
    >
      <TabbedForm
        initialValues={{ person, legalPerson }}
        redirect={
          person
            ? `/people/${person}/show/incomes`
            : `/legal-people/${legalPerson}/show/incomes`
        }
        variant='outlined'
      >
        <FormTab label='Ingresos'>
          <IncomeForm />
        </FormTab>
      </TabbedForm>
    </Create>
  );
};

export default IncomeCreate;
